import React, { useMemo } from "react";
import VideoPlayer3 from "./VideoPlayer3/VideoPlayer3";
import VideoPlayer2 from "./VideoPlayer2/VideoPlayer2";
import { isIOS } from "../../../Utils/is_IOS";
import { I_TechItemPart } from "../../../Models/interfaces";

type VideoPlayerProps = {
  userNumber: string;
  videoUrl: string;
  extraChild?: React.ReactNode;
  currDataIndex: number;
  teachData?: I_TechItemPart;
  onVideoSelected: () => void;
  setCurrDataIndex: React.Dispatch<React.SetStateAction<number>>;
};

const VideoPlayer: React.FunctionComponent<VideoPlayerProps> = ({
  userNumber,
  videoUrl,
  extraChild,
  currDataIndex,
  teachData,
  onVideoSelected,
  setCurrDataIndex,
}) => {
  const video1 = useMemo(
    () =>
      isIOS() ? (
        <VideoPlayer2
            videoSrc={videoUrl}
            userNumber={userNumber}
            currDataIndex={currDataIndex}
            teachData={teachData}
            onVideoSelected={onVideoSelected}
            setCurrDataIndex={setCurrDataIndex}
        />
      ) : (
      <VideoPlayer3
        videoSrc={videoUrl}
        userNumber={userNumber}
        currDataIndex={currDataIndex}
        teachData={teachData}
        onVideoSelected={onVideoSelected}
        setCurrDataIndex={setCurrDataIndex}
      />
    ),
    [videoUrl, userNumber]
  );
  return (
    <div className="w-full relative">
      {video1}
      {extraChild}
    </div>
  );
};

export default VideoPlayer;
